// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7db377ea","239":"1025e6aa","453":"b03e3c98","732":"0fff38bf"}[chunkId] + ".chunk.js";
};